<template>
  <div class="fileview">
    <div class="tagtitle">{{ fileList.length }}个附件</div>
    <ul :class="isFlex ? 'flex-ul' : ''">
      <li
        v-for="file in fileList"
        :key="file.ID"
        :class="isFlex ? 'flex-li' : ''"
      >
        <div class="filecontent">
          <div style="display:flex;align-items:center">
            <div class="image">
              <img class="img" :src="matchTypeImg(file.FILEPATH)" alt srcset />
            </div>
            <div class="filetitle">{{ file.FILENAME }}</div>
          </div>
          <div class="file-btnDiv">
            <div
              v-if="matchType(file.FILENAME)"
              @click="fileView(file.FILEPATH, file.FILENAME)"
              class="filebutton view"
            >
              预览
            </div>
            <div class="filebutton download" @click="download(file.ID)">
              下载
            </div>
            <div
              class="filebutton del"
              v-show="isEdit"
              @click="del(file.ID, file._id)"
            >
              删除
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  Download2,
  GetVideoPlayAddress
} from "@/api/modules/basicData/commonData";
export default {
  name: "fileListView",
  props: {
    fileList: {
      type: Array,
      default: []
    },
    isFlex: {
      type: Boolean,
      default: false
    },
    isEdit: {
      //是否允许删除
      type: Boolean,
      default: true
    },
    idIsUrl: {
      //id是否是URL
      type: Boolean,
      default: true
    }
  },
  methods: {
    download(id) {
      console.log("url", id);
      if (id.indexOf("DownloadFileById") == -1) {
        let url = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + id;
        console.log("url", url);
        window.location.href = url;
      } else {
        window.location.href = id;
      }
    },
    del(id, _id) {
      let fileId = this.fileList
        .find(file => file.ID == id)
        .ID.split("?")[1]
        .slice(3);
      let index = this.fileList.findIndex(file => file.ID == id);
      this.fileList.splice(index, 1);
      this.$emit("del", _id);
      this.$emit("delFiles", fileId);
    },
    // 根据文件名后缀区分 文件类型
    /*
     * @param: fileName - 文件名称
     * @param: 数据返回 1) 无后缀匹配 - false
     * @param: 数据返回 2) 匹配图片 - image
     * @param: 数据返回 3) 匹配 txt - txt
     * @param: 数据返回 4) 匹配 excel - excel
     * @param: 数据返回 5) 匹配 word - word
     * @param: 数据返回 6) 匹配 pdf - pdf
     * @param: 数据返回 7) 匹配 ppt - ppt
     * @param: 数据返回 8) 匹配 视频 - video
     * @param: 数据返回 9) 匹配 音频 - radio
     * @param: 数据返回 10) 其他匹配项 - other
     */
    matchType(fileName) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false;
        return result;
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = [
        "doc",
        "docx",
        "ppt",
        "pptx",
        "xls",
        "xlsx",
        "zip",
        "mp4",
        "m2v",
        "mkv",
        "avi",
        "flv",
        "mov",
        "rmvb",
        "mpeg",
        "3gp",
        "wmv",
        "swf",
        "mp3",
        "txt",
        "pdf",
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif"
      ];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      return result;
    },
    fileView(filepath, filename) {
      //  var videolist = ["mp4", "m2v", "mkv"]
      console.log(filepath);
      var winHeight = window.document.documentElement.clientHeight - 60;
      var winWidth = window.document.documentElement.clientWidth - 100;
      let suffix = "";
      try {
        var flieArr = filepath.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      suffix = suffix.toLowerCase();
      let videolist = [
        "mp4",
        "m2v",
        "mkv",
        "avi",
        "flv",
        "mov",
        "rmvb",
        "mpeg",
        "3gp",
        "wmv",
        "swf"
      ];
      console.log(suffix);
      console.log(videolist.indexOf(suffix));
      if (videolist.indexOf(suffix) >= 0) {
        console.log("matchTypeImg");
        let arr = filepath.split("\\");
        let name = arr[arr.length - 1];
        GetVideoPlayAddress(name.split(".")[0], filename.split(".")[0]).then(
          address => {
            console.log(address);
            address = this.Video_ROOT + address;
            if (address) {
              window.open(
                address,
                "_blank",
                "height=" +
                  winHeight +
                  ",width=" +
                  winWidth +
                  ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes"
              );
            }
          }
        );
      } else {
        filepath = filepath.replace(/\\/g, "/");
        if (process.env.Is_ViewApi) {
          Download2(filepath).then(res => {
            var fileurl = this.File_ROOT + res.replace(/\\/g, "/");
            var url = this.OnlinePreview + fileurl;
            var winHeight = window.document.documentElement.clientHeight - 60;
            var winWidth = window.document.documentElement.clientWidth - 100;
            window.open(
              url,
              "_blank",
              "height=" +
                winHeight +
                ",width=" +
                winWidth +
                ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes"
            );
          });
        } else {
          var fileurl = this.File_ROOT + filepath;
          var url = this.OnlinePreview + fileurl;
          var winHeight = window.document.documentElement.clientHeight - 60;
          var winWidth = window.document.documentElement.clientWidth - 100;
          window.open(
            url,
            "_blank",
            "height=" +
              winHeight +
              ",width=" +
              winWidth +
              ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes"
          );
        }
      }
    },
    // 根据文件名后缀区分 文件类型
    /*
     * @param: fileName - 文件名称
     * @param: 数据返回 1) 无后缀匹配 - false
     * @param: 数据返回 2) 匹配图片 - image
     * @param: 数据返回 3) 匹配 txt - txt
     * @param: 数据返回 4) 匹配 excel - excel
     * @param: 数据返回 5) 匹配 word - word
     * @param: 数据返回 6) 匹配 pdf - pdf
     * @param: 数据返回 7) 匹配 ppt - ppt
     * @param: 数据返回 8) 匹配 视频 - video
     * @param: 数据返回 9) 匹配 音频 - radio
     * @param: 数据返回 10) 其他匹配项 - other
     */
    matchTypeImg(fileName) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return require("../../assets/img/file.png");
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "image";
        return this.File_ROOT + fileName.replace(/\\/g, "/");
      }
      // 匹配txt
      var txtlist = ["txt"];
      result = txtlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        return require("../../assets/img/file.png");
      }
      // 匹配 excel
      var excelist = ["xls", "xlsx"];
      result = excelist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "excel";
        return require("../../assets/img/xls.png");
      }
      // 匹配 word
      var wordlist = ["doc", "docx"];
      result = wordlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "word";
        return require("../../assets/img/word.png");
      }
      // 匹配 pdf
      var pdflist = ["pdf"];
      result = pdflist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "pdf";
        return require("../../assets/img/file.png");
      }
      // 匹配 ppt
      var pptlist = ["ppt"];
      result = pptlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "ppt";
        return require("../../assets/img/PPT.png");
      }
      // 匹配 视频
      var videolist = [
        "mp4",
        "m2v",
        "mkv",
        "avi",
        "flv",
        "mov",
        "rmvb",
        "mpeg",
        "3gp",
        "wmv",
        "swf"
      ];
      result = videolist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "video";
        return require("../../assets/img/video.png");
      }
      // 匹配 音频
      var radiolist = ["mp3", "wav"];
      result = radiolist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "radio";
        return require("../../assets/img/mp3.png");
      }
      // 其他 文件类型
      result = "other";
      return require("../../assets/img/file.png");
    }
  }
};
</script>

<style scoped>
.file-btnDiv {
  font-size: 12px;
}
.tagtitle {
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}
.fileview ul {
  /*ul向div父元素右方浮动*/
  list-style: none;
  /*将默认的列表符号去掉*/
  margin: 0;
  /* 将默认的内边距去掉 */
  padding: 0px;
  /* 将默认的外边距去掉 */
}
.fileview li {
  list-style: none;
  margin: 5px 20px 0px 0px;
  /* padding: 20px 0px 30px 0px; */
  /* width: 15%; */
  /* float: left; */
  text-align: center;
  display: flex;
  /* font-size: 20px; */
  color: #5b6379;
  /* cursor: pointer; */
  /*li标签按顺序向ul父元素左方浮动*/
}
.image {
  width: 30px;
  height: 30px;
  /* border:1px solid black; */
  position: relative;
}
.filetitle {
  margin-left: 5px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  color: #858585;
}
.filecontent {
  float: left;
  margin-left: 5px;
}
.filebutton {
  margin: 5px 10px 2px 10px;
  float: left;
  cursor: pointer;
}
.view {
  color: #ff9a40;
}
.download {
  color: #409eff;
}
.del {
  color: red;
}
.img {
  width: 30px;
  height: 30px;
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
}
.flex-ul {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-li {
  width: auto;
  /* margin-top: 10px;
  margin-right: 10px; */
}
</style>
